import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Contacto() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [form, setForm] = useState({ nombre: "", correo: "", mensaje: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { nombre, correo, mensaje } = form;
    const text = `Hola Promequi,%0AQuiero más información.%0A%0ANombre: ${encodeURIComponent(
      nombre
    )}%0ACorreo: ${encodeURIComponent(correo)}%0AMensaje: ${encodeURIComponent(mensaje)}`;
    window.open(`https://wa.me/50259786302?text=${text}`, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="bg-white text-slate-800">
      {/* Estilos locales mínimos */}
      <style>{`
        :root{
          --brand:#244A9B;
          --brand-soft:#9EC2FF;
          --ink:#0F1D43;
        }
        .soft{box-shadow:0 12px 30px rgba(15,29,67,.06),0 6px 14px rgba(15,29,67,.05)}
        .btn{display:inline-flex;align-items:center;justify-content:center;border-radius:0.75rem;padding:.75rem 1.25rem;font-weight:600;transition:.2s}
        .btn-brand{background:var(--brand);color:#fff}
        .btn-brand:hover{filter:brightness(.93)}
        .btn-light{background:#fff;color:#334155;border:1px solid #e2e8f0}
        .nav-link{font-size:.95rem;font-weight:700;letter-spacing:.02em;color:#475569}
        .nav-link:hover{color:#0f172a}
      `}</style>

      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-24 flex items-center justify-between">
            {/* Logo → SPA */}
            <Link to="/" className="flex items-center gap-3" aria-label="Inicio Promequi">
              <img src="/assets/logo.png" alt="Logo Promequi" className="h-10 w-auto sm:h-12 md:h-16 lg:h-24" />
            </Link>
            <nav className="hidden md:flex items-center gap-8">
              <Link className="nav-link" to="/">HOME</Link>
            </nav>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setMobileOpen((v) => !v)}
                className="md:hidden p-2 rounded-lg border border-slate-200"
                aria-label="Abrir menú"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 6h16M4 12h16M4 18h16"/>
                </svg>
              </button>
            </div>
          </div>
          {mobileOpen && (
            <div className="md:hidden pb-4" id="mobileNav">
              <div className="flex flex-col gap-3 text-sm">
                <Link to="/" className="py-2" onClick={() => setMobileOpen(false)}>HOME</Link>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Hero Contacto */}
      <section className="py-10 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight" style={{ color: "var(--ink)" }}>
            Contacto
          </h1>
          <p className="text-slate-600 mt-2">Escríbenos y con gusto te respondemos.</p>
        </div>
      </section>

      {/* Mapa + Formulario */}
      <section className="pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-start">
          {/* Mapa */}
          <div>
            <h2 className="text-lg font-bold mb-3" style={{ color: "var(--ink)" }}>
              Nuestra ubicación
            </h2>
            <div className="aspect-video rounded-3xl overflow-hidden soft border border-slate-100">
              <iframe
                src="https://www.google.com/maps?q=14.64355883,-90.56553841&hl=es&z=16&output=embed"
                width="600"
                height="450"
                style={{ border: 0, width: "100%", height: "100%" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                title="Ubicación Promequi"
              />
            </div>

            {/* Waze */}
            <div className="mt-10 text-sm text-slate-600">
              <a
                href="https://ul.waze.com/ul?ll=14.64355883%2C-90.56553841&navigate=yes&zoom=17&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sky-700 font-semibold"
              >
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <h2 className="text-xl font-extrabold text-center sm:text-left">
                    <span className="sm:hidden">DALE CLICK AQUÍ 👇</span>
                    <span className="hidden sm:inline">DALE CLICK AQUÍ 👉</span>
                  </h2>
                  <img
                    src="/assets/waze.jpg"
                    alt="Abrir en Waze"
                    className="w-48 sm:w-56 mx-auto sm:mx-0 rounded-xl soft transition-transform duration-200 hover:scale-105"
                  />
                </div>
              </a>
            </div>
          </div>

          {/* Formulario */}
          <div className="bg-slate-50 rounded-2xl p-6 soft border border-slate-100">
            <h2 className="text-xl font-extrabold" style={{ color: "var(--ink)" }}>
              Escríbenos
            </h2>
            <form className="mt-4 space-y-3" onSubmit={handleSubmit}>
              <div>
                <label className="text-sm font-medium text-slate-700">Nombre</label>
                <input
                  type="text"
                  name="nombre"
                  value={form.nombre}
                  onChange={handleChange}
                  className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-300"
                  required
                />
              </div>
              <div>
                <label className="text-sm font-medium text-slate-700">Correo</label>
                <input
                  type="email"
                  name="correo"
                  value={form.correo}
                  onChange={handleChange}
                  className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-300"
                  required
                />
              </div>
              <div>
                <label className="text-sm font-medium text-slate-700">Mensaje</label>
                <textarea
                  name="mensaje"
                  rows="4"
                  value={form.mensaje}
                  onChange={handleChange}
                  className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-300"
                  required
                />
              </div>
              <button type="submit" className="btn btn-brand w-full">Enviar por WhatsApp</button>
              <p className="text-xs text-slate-500">Al enviar, se abrirá WhatsApp con tu mensaje.</p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-center divide-y md:divide-y-0 md:divide-x divide-slate-300">
            {/* Columna izquierda */}
            <div className="w-full md:w-auto text-center px-0 md:px-8 pb-6 md:pb-0">
              <div className="font-extrabold tracking-wide text-slate-800">PROMEQUI</div>
              <div className="mt-2 text-m text-slate-600">
                2 Calle 16-53, Zona 4 Mixco <br />
                Col. Valle Del Sol <br />
                Teléfono:{" "}
                <a className="font-extrabold tracking-wide text-slate-800 underline" href="tel:+50224372562">2437-2562</a> /{" "}
                <a className="font-extrabold tracking-wide text-slate-800 underline" href="tel:+50224372503">2437-2503</a> /{" "}
                <a className="font-extrabold tracking-wide text-slate-800 underline" href="tel:+50224341904">2434-1904</a>
                <br />
                Correo: <a href="mailto:info@promequi.com.gt">info@promequi.com.gt</a> <br />
                Horario de atención: 09:00 am a 02:00 pm
              </div>
            </div>

            {/* Columna derecha (WhatsApp) */}
            <div className="w-full md:w-auto text-center px-0 md:px-8 pt-6 md:pt-0">
              <a
                href="https://wa.me/50259786302?text=Hola%20Promequi%2C%20quisiera%20informaci%C3%B3n"
                className="inline-flex"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Escríbenos por WhatsApp"
                title="WhatsApp"
              >
                <img src="/assets/whatsapp.png" alt="WhatsApp" className="h-16 w-16 mx-auto" />
                <p className="pl-8 flex items-center justify-center">¿CONSULTAS? 👈🏼</p>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
